import { TrainingSaveProgressAction } from './../action/TrainingActions';
import { Actions, Effect } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { TrainingActionTypes, UserActionTypes } from '../action';
import { TrainingListAction, TrainingListClientAction, TrainingListAppliedAction, TrainingListContentAction, TrainingListQuizAction, TrainingSaveQuizAction, TrainingGetProgressAction, TrainingStatusUpdateAction, TrainingActions } from '../action/TrainingActions';
import { TrainingService } from '../../services/TrainingSevice';
import { Observable } from 'rxjs';

@Injectable()
export class TrainingEffects {

    constructor(
        private actions: Actions<TrainingActions>,
        private trainingService: TrainingService
    ) {

    }

    @Effect()
    list$ = this.actions.ofType(TrainingActionTypes.TRAINING_LIST)
        .map((action: TrainingListAction) => action)
        .switchMap(action => this.trainingService.listTrainings(1)
            .map(response => ({ type: TrainingActionTypes.TRAINING_LIST_SUCCESS, categories: response }))
            .catch(error => Observable.of({ type: TrainingActionTypes.TRAINING_LIST_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    listClient$ = this.actions.ofType(TrainingActionTypes.TRAINING_LIST_CLIENT)
        .map((action: TrainingListClientAction) => action)
        .switchMap(action => this.trainingService.listTrainings(action.payload.clientId)
            .map(response => ({ type: TrainingActionTypes.TRAINING_LIST_CLIENT_SUCCESS, categories: response }))
            .catch(error => Observable.of({ type: TrainingActionTypes.TRAINING_LIST_CLIENT_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    listApplied$ = this.actions.ofType(TrainingActionTypes.TRAINING_LIST_APPLIED)
        .map((action: TrainingListAppliedAction) => action)
        .switchMap(action => this.trainingService.listAppliedTrainings(action.payload.userId)
            .map(response => ({ type: TrainingActionTypes.TRAINING_LIST_APPLIED_SUCCESS, appliedTrainings: response }))
            .catch(error => Observable.of({ type: TrainingActionTypes.TRAINING_LIST_APPLIED_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    listContent$ = this.actions.ofType(TrainingActionTypes.LOAD_CONTENT)
        .map((action: TrainingListContentAction) => action)
        .switchMap(action => this.trainingService.listTrainingContent(action.payload.trainingId)
            .map(response => ({ type: TrainingActionTypes.LOAD_CONTENT_SUCCESS, content: response }))
            .catch(error => Observable.of({ type: TrainingActionTypes.LOAD_CONTENT_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    listQuiz$ = this.actions.ofType(TrainingActionTypes.LOAD_QUIZ)
        .map((action: TrainingListQuizAction) => action)
        .switchMap(action => this.trainingService.listTrainingQuiz(action.payload.clientId, action.payload.quizList)
            .map(response => ({ type: TrainingActionTypes.LOAD_QUIZ_SUCCESS, quiz: response }))
            .catch(error => Observable.of({ type: TrainingActionTypes.LOAD_QUIZ_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    saveQuiz$ = this.actions.ofType(TrainingActionTypes.SAVE_QUIZ)
        .map((action: TrainingSaveQuizAction) => action)
        .switchMap(action => this.trainingService.saveTrainingQuiz(action.payload.data)
            .map(response => ({ type: TrainingActionTypes.SAVE_QUIZ_SUCCESS }))
            .catch(error => Observable.of({ type: TrainingActionTypes.SAVE_QUIZ_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    saveProgress$ = this.actions.ofType(TrainingActionTypes.SAVE_PROGRESS)
        .map((action: TrainingSaveProgressAction) => action)
        .switchMap(action => this.trainingService.saveTrainingProgress(action.payload.data)
            .map(response => ({ type: TrainingActionTypes.SAVE_PROGRESS_SUCCESS}))
            .catch(error => Observable.of({ type: TrainingActionTypes.SAVE_PROGRESS_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    getProgress$ = this.actions.ofType(TrainingActionTypes.GET_PROGRESS)
        .map((action: TrainingGetProgressAction) => action)
        .switchMap(action => this.trainingService.getTrainingProgress(action.payload.clienteId, action.payload.alunoId, action.payload.cursoId)
            .map(response => ({ type: TrainingActionTypes.GET_PROGRESS_SUCCESS, progress: response}))
            .catch(error => Observable.of({ type: TrainingActionTypes.GET_PROGRESS_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    saveStatus$ = this.actions.ofType(TrainingActionTypes.SAVE_STATUS)
        .map((action: TrainingStatusUpdateAction) => action)
        .switchMap(action => this.trainingService.saveTrainingStatus(action.payload.data)
            .map(response => ({ type: TrainingActionTypes.SAVE_STATUS_SUCCESS}))
            .catch(error => Observable.of({ type: TrainingActionTypes.SAVE_STATUS_ERROR, errorPayload: { errorStatus: error.status } }))
        );

    @Effect()
    errorStatus401$ = this.actions
        .map(action => action.errorPayload)
        .filter(payload => payload && (payload.errorStatus === 401 || payload.errorStatus === 0))
        .switchMap(() => Observable.of({ type: UserActionTypes.USER_EXPIRED }));

}


// WEBPACK FOOTER //
// ./src/store/effects/TrainingEffects.ts